import {createAction, createAsyncAction} from 'typesafe-actions'
import type {PartialTask, ServerTask, Task} from '../../../responses/tasks'
import type {DepartmentWithUsers} from '../../../responses/departments'
import type {NormalizedDepartment} from '../../../responses/refs/refs'
import {ID} from '../../../types/UtilityTypes'
import {DepartmentTasksFilters} from './TaskFilters'

export const taskListActions = {
    departments: createAsyncAction(
        '@TASK_LIST/DEPARTMENTS_REQUEST',
        '@TASK_LIST/DEPARTMENTS_SUCCESS',
        '@TASK_LIST/DEPARTMENTS_FAILURE',
        '@TASK_LIST/DEPARTMENTS_CANCEL',
    )<DepartmentTasksFilters, DepartmentWithUsers[], void, void>(),
    open: createAsyncAction(
        '@TASK_LIST/OPEN_REQUEST',
        '@TASK_LIST/OPEN_SUCCESS',
        '@TASK_LIST/OPEN_FAILURE',
    )<{ task: Task, changes: PartialTask }, ServerTask, void>(),
    setTasks: createAction('@TASK_LIST/SET_TASKS')<ID[]>(),
    setFilter: createAction('@TASK_LIST/SET_FILTER')<NormalizedDepartment[]>(),
}